import { MANAGE_GENERATABLE_DOCUMENTS_ROUTES } from '@dealstack/frontend/admin/pages/Manage/ManageGeneratableDocuments/ManageGeneratableDocuments.tsx';
import { GODMODE_ROOT_ROUTES } from '@dealstack/frontend/admin/pages/Routing/Routing.tsx';
import { generatePath } from 'react-router-dom';

export const generatableDocumentEditPath = (templateId: string): string =>
	generatePath(
		`${GODMODE_ROOT_ROUTES.MANAGE_GENERATABLE_DOCUMENTS}/${MANAGE_GENERATABLE_DOCUMENTS_ROUTES.EDIT}`,
		{ templateId }
	);
